import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../components/Modal/Modal'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { InviteResponse, useDeleteInviteMutation } from '../../store/auth/auth'
import { planApi } from '../../store/plan/plan'

interface DeleteInviteModalProps {
  invite?: InviteResponse
  show: boolean
  onHide: () => void
}

export const DeleteInviteModal: React.FC<DeleteInviteModalProps> = ({ invite, show, onHide }) => {
  const accountId = useAppSelector(selectAccountId)
  const [deleteInvite, deleteInviteResult] = useDeleteInviteMutation()
  const dispatch = useAppDispatch()

  const handleDeleteUser = async () => {
    if (invite) {
      deleteInvite({ accountId: accountId, inviteId: invite.id })
      dispatch(planApi.util.invalidateTags(['BillingCustomer']))
    }
  }

  useEffect(() => {
    if (deleteInviteResult.isSuccess) {
      onHide()
    }
  }, [deleteInviteResult, onHide])

  if (!invite) {
    return null
  }

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Invitation</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Are you sure you want to delete invitation for email <b>{invite.user.email}</b> ?
          </div>
        </Col>
      </Row>
      <Row></Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleDeleteUser}
      footerPrimaryActionLoading={deleteInviteResult.isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    ></Modal>
  )
}
